module.exports = __webpack_public_path__ + "img/545.9b4529ad.png";